export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./casino-home-custom-banner-2.vue?vue&type=template&id=2b0c6e1f"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/casino-home-custom-banner-2.vue?vue&type=template&id=2b0c6e1f
// module id = Vt2N
// module chunks = 0